import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import KPIDashboard from "./KPIDashboard";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80vw",
  height: "80vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  borderRadius: 1,
  overflow: "scroll",
};

export default function KPIDashboardModal() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Box>
      <Button
        sx={{
          bgcolor: "blue.main",
          color: "white.main",
          textTransform: "none",
          fontWeight: "bold",
          mt: 1,
          "&:hover": {
            bgcolor: "skyBlue.main",
            color: "black.main",
          },
          marginLeft: "calc(100% -500px)",
        }}
        onClick={handleOpen}
      >
        View KPI Dashboard
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="subtitle1" sx={{ color: "blue.main", mb: 2 }}>
            KPI Dashboard
          </Typography>
          <KPIDashboard />
        </Box>
      </Modal>
    </Box>
  );
}
